import { useEffect, useState, useRef } from "react";
import "../styles/FileUpload.css";

const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ALLOWED_TYPE = "application/pdf";

const FileUpload = ({ onFileSelected }) => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");
    const [isDraggedOver, setIsDraggedOver] = useState(false);
    const containerRef = useRef(null);

    const validateFile = (file) => {
        if (file.type !== ALLOWED_TYPE) {
            setError("Only PDF files are allowed.");
            return false;
        }
        if (file.size > MAX_FILE_SIZE) {
            setError("File size exceeds 10MB. Please select a smaller file.");
            return false;
        }
        setError("");
        return true;
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile && validateFile(selectedFile)) {
            setFile(selectedFile);
        } else {
            setFile(null);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDraggedOver(false);

        const droppedFile = event.dataTransfer.files[0];
        if (droppedFile && validateFile(droppedFile)) {
            setFile(droppedFile);
        } else {
            setFile(null);
        }
    };

    const handleDragEnter = (event) => {
        event.preventDefault();
        if (containerRef.current.contains(event.target)) {
            setIsDraggedOver(true);
        }
    };

    const handleDragLeave = (event) => {
        if (event.relatedTarget && containerRef.current.contains(event.relatedTarget)) {
            return;
        } else {
            setIsDraggedOver(false);
        }
    };

    useEffect(() => {
        onFileSelected(file);
    }, [file, onFileSelected]);

    return (
        <div
            ref={containerRef}
            className={`upload-file ${isDraggedOver ? "drag-over" : ""}`}
            onDrop={handleDrop}
            onDragOver={(event) => event.preventDefault()}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
        >
            <p>Drag & Drop your PDF file here</p>
            <input
                type="file"
                hidden
                id="browseFile"
                onChange={handleFileChange}
                accept=".pdf"
            />
            <label htmlFor="browseFile" className="upload-file-btn">
                Browse File
            </label>
            <p className="msg">Allowed file format: PDF</p>
            <p className="msg">Maximum upload size: 10MB</p>

            {error && <p className="error-message">{error}</p>}
            {file && <p style={{ color: 'Green' }}>{file.name}</p>}
        </div>
    );
};

export default FileUpload;
